import * as DOM from '../dom/dom.js';  // DOM manipulation
import * as Ecosystem from '../ecosystem/ecosystem';  // Ecosystem class

/**
 * Build the Top Bar.
 *
 * @param  {object}  jwt     The JWT object
 * @param  {string}  apiUrl  API URL
 * @return {object}          The account div
 */
export function build(jwt, apiUrl)
{
	var barDiv = document.getElementById('topbar');
	// barDiv.appendChild(_createAccountDiv(jwt));
	barDiv.appendChild(_createEnvDiv(jwt, apiUrl));
}

/**
 * Create the account div.
 *
 * @param  {object}  jwt  The JWT object
 * @return {object}       The account div
 */
/*
function _createAccountDiv(jwt)
{
	// Create the account div
	var wrap = DOM.create('div', { class: 'account' });

	// Create children
	var initials = DOM.create('span', { id: 'initials', 'data-initial': jwt.uname.charAt(0).toUpperCase() }, {}, jwt.aname);
	var opened = DOM.create('div', { class: 'opened' });

	// Logout link
	var logout = DOM.create('a', { id: 'logout', href: '/login/out' });
	logout.appendChild(DOM.create('span', {}, {}, 'Logout'));

	// Append elements to the "opened" div
	opened.appendChild(DOM.create('span', { id: 'aname' }, {}, jwt.aname));
	opened.appendChild(DOM.create('span', { id: 'uname' }, {}, jwt.uname));
	opened.appendChild(logout);

	// Append children to the account div
	wrap.appendChild(initials);
	wrap.appendChild(opened);

	// Return the account div
	return wrap;
}
*/

/**
 * Create the environment div.
 *
 * @param  {object}  jwt     The JWT object
 * @param  {string}  apiUrl  API URL
 * @return {object}          The environment div
 */
function _createEnvDiv(jwt, apiUrl)
{
	// Get active language
	const lang = _getLanguage();

	// Create the environment div
	// var wrap = DOM.create('div', { class: 'env' });
	// var wrap = DOM.create('div', { class: 'account' });
	var wrap = DOM.create('div', { class: 'wowcast' });

	// First child: the opener link (with user initials)
	// var icon = DOM.create('a', { class: 'fa-icon open' })
	// icon.appendChild(DOM.create('span', {}, {}, 'WowCast Environment'));
	// wrap.appendChild(icon);
	var outerInitials = DOM.create('span', { class: 'initials', 'data-initial': jwt.uname.charAt(0).toUpperCase() }, {}, '');
	outerInitials.innerHTML = '&nbsp;';
	wrap.appendChild(outerInitials);

	// Second child: the "opened" div
	var opened = DOM.create('div', { class: 'opened' });
	wrap.appendChild(opened);

	// Add an internal copy of user initials
	var innerInitials = DOM.create('span', { class: 'initials', 'data-initial': jwt.uname.charAt(0).toUpperCase() }, {}, '');
	innerInitials.innerHTML = '&nbsp;';
	opened.appendChild(innerInitials);

	// Append elements to the "opened" div
	opened.appendChild(DOM.create('span', { id: 'uname' }, {}, jwt.uname));
	opened.appendChild(DOM.create('span', { id: 'aname' }, {}, jwt.aname));

	// Append label to "opened" div
	opened.appendChild(DOM.create('span', { class: 'ecosystem' }, {}, (lang == 'en') ? 'WowCast Services' : 'Servicios WowCast'));

	// Create and append box for services list
	var servicesList = DOM.create('div', { class: 'services' }, { marginBottom: '0' });
	opened.appendChild(servicesList);

	// Call the server to get services
	Ecosystem.apiCall('GET', '/v1/auth/bootstrap')

		// Handle positive response
		.then(response =>
		{
			// Loop through services
			for (let service of response.data.services)
			{
				// let service = data.domains[key];
				service.class = 'fa-icon wowcast-' + service.key;
				if (service.url.split('/')[2] == document.location.hostname) service.class += ' active';

				var link = DOM.create('a', { class: service.class, href: service.url, target: '_blank' }, {}, service.name.split(' ')[0]);
				if (!service.enabled) link.setAttribute('disabled', '');
				servicesList.appendChild(link);
			}

			// Append custom styles
			let style = '';
			style += '#topbar a.wowcast-D:before { content: "\\f625"; }' + "\n";
			style += '#topbar a.wowcast-N:before { content: "\\f144"; }' + "\n";
			style += '#topbar a.wowcast-A:before { content: "\\f09c"; }' + "\n";
			style += '#topbar a.wowcast-Q:before { content: "\\f51c"; }' + "\n";
			style += '#topbar a.wowcast-M:before { content: "\\f302"; }' + "\n";
			style += '#topbar a.wowcast-C:before { content: "\\f2bb"; }' + "\n";
			document.head.appendChild(DOM.create('style', {}, {}, style));
		})

		// Handle errors
		.catch(error =>
		{
			// Append error message to "opened" div
			opened.appendChild(DOM.create('span', {}, {}, error.message ? error.message : error));
		});

	// Create languages options
	var languages = DOM.create('div', { class: 'languages' });
	var languages_label = DOM.create('span', { class: 'languages-label' }, {}, 'Idioma' + ':');
	var language_es = DOM.create('a', { class: 'languages-spanish' + (lang == 'es' ? ' active' : ''), title: 'Español', 'data-lang': 'es' });
	var language_en = DOM.create('a', { class: 'languages-english' + (lang == 'en' ? ' active' : ''), title: 'English', 'data-lang': 'en' });

	// Append languages options to "opened" div
	opened.appendChild(languages);
	languages.appendChild(languages_label);
	languages.appendChild(language_es);
	languages.appendChild(language_en);

	// Add click handler to language options
	language_es.addEventListener('click', () => _switchLanguage('es'));
	language_en.addEventListener('click', () => _switchLanguage('en'));

	// Append logout to the "opened" div
	// Logout link
	var logout = DOM.create('a', { id: 'logout', href: '/logout' });
	logout.appendChild(DOM.create('span', {}, {}, 'Logout'));
	opened.appendChild(logout);

	// Return the account div
	return wrap;
}

/**
 * Get the active language.
 *
 * @returns  {string}  The active language
 */
function _getLanguage()
{
	// Get language (cookie first, then document)
	var lang = Cookies.get('lang');
	if (!lang) lang = document.documentElement.lang;
	if (!lang) lang = 'en';

	// Save back language
	_setLanguage(lang);

	// Return language
	return lang;
}

/**
 * Set the active language.
 *
 * @param  {string}  lang  The language to set
 */
function _setLanguage(lang)
{
	// Update language UI
	document.querySelectorAll('.languages a').forEach(el =>
	{
		if (el.dataset.lang === lang) el.classList.add('active');
		else el.classList.remove('active');
	});

	// Save language cookie
	Cookies.set('lang', lang, 8640000, { path: '/', domain: 'wowcast.co', samesite: 'Strict', secure: true });  // 100 days
}

/**
 * Switch language.
 *
 * @param  {string}  lang  The language to switch to
 */
function _switchLanguage(lang)
{
	// Set language
	_setLanguage(lang);

	// Reload the page
	window.location.reload();
}